import { TypeFeature } from '../types/general-types';
import {
  FEATURES,
  FEATURES_INFO,
  formatNumber,
  PRODUCT_LIMITATION_LIMITED_LEGACY,
  PRODUCT_LIMITATION_LIMITED,
  UNLIMITED_STRING,
} from '../constants';
import { PRODUCT } from '../components/Mobile/mobile-constant';
import { data } from '../globals';

const isInfoDescriptionExists = (key: string, arrayTranslated: any) => {
  const ketInfo = key.replace(FEATURES, FEATURES_INFO);
  return arrayTranslated[ketInfo] !== undefined;
};

const getInfoDescription = (key: any): string =>
  key.replace(FEATURES, FEATURES_INFO);

const getMore = (itemKey: string) => {
  return !!itemKey.match(/^features.{1,}more./gm);
};

const getOrder = (itemKey: string) => {
  const featureKeyOrderStart =
    itemKey.indexOf('.more.') !== -1
      ? itemKey.indexOf('.more.')
      : itemKey.indexOf('.less.');
  return itemKey.substr(featureKeyOrderStart + 6);
};

const sortByOrder = (array: { order: string }[]) => {
  array.sort((featureA: any, featureB: any) =>
    featureA.order < featureB.order
      ? -1
      : featureA.order > featureB.order
      ? 1
      : 0,
  );
};

export const transformFeatures = (translatedArray: Object): TypeFeature[] => {
  const arrayTranslated = Object.entries(translatedArray);
  const translatedList: any = arrayTranslated
    .filter((item) => item[0].startsWith(FEATURES))
    .map((item) => {
      const itemKey = item[0];
      const infoDescription = isInfoDescriptionExists(itemKey, translatedArray)
        ? getInfoDescription(itemKey)
        : undefined;
      const more = getMore(itemKey);
      const order = getOrder(itemKey);
      return {
        description: itemKey,
        more,
        infoDescription,
        order,
      };
    });

  sortByOrder(translatedList);

  const returnFeatures = translatedList.map((feature: any) => ({
    description: feature.description,
    more: feature.more,
    infoDescription: feature.infoDescription,
  }));
  return returnFeatures;
};

const translateUnlimited = (
  key: string,
  str: any,
  unlimitedString: string,
  groupSeparator: string,
  decimalSeparator: string,
) => {
  if (key === 'emailsSendMonth') {
    return formatNumber(str, decimalSeparator, groupSeparator);
  }
  return str === UNLIMITED_STRING ? unlimitedString : str;
};

const getProductLimitationTranslated = (
  limitation: object,
  unlimitedString: string,
  groupSeparator: string,
  decimalSeparator: string,
) => {
  const returnLimitation = {};
  for (const [key, value] of Object.entries(limitation)) {
    const entry = Object.create({});
    entry[key] = translateUnlimited(
      key,
      value,
      unlimitedString,
      groupSeparator,
      decimalSeparator,
    );
    Object.assign(returnLimitation, entry);
  }

  return returnLimitation;
};

export const getProductLimitationByIndex = (
  index: PRODUCT,
  unlimitedString: string,
  activeExperiments?: any,
) => {
  const { decimalSeparator, groupSeparator } = data.currency;
  if (index === PRODUCT.FREE) {
    return getProductLimitationTranslated(
      activeExperiments.showAscendMonetizationChanges
        ? PRODUCT_LIMITATION_LIMITED
        : PRODUCT_LIMITATION_LIMITED_LEGACY,
      unlimitedString,
      groupSeparator,
      decimalSeparator,
    );
  } else if (
    index === PRODUCT.BASIC ||
    index === PRODUCT.PRO ||
    index === PRODUCT.UNLIMITED
  ) {
    return getProductLimitationTranslated(
      data.getProductLimitations(index),
      unlimitedString,
      groupSeparator,
      decimalSeparator,
    );
  } else {
    return {};
  }
};
